import React from "react";
import { UserCircleIcon } from "@heroicons/react/24/solid";

/**
 * Avatar for notification rows (photo or fallback icon).
 * @param {string} [className="h-9 w-9"] — Tailwind size classes for the glyph/photo.
 */
const NotificationAvatar = ({ url, label, className = "h-9 w-9" }) => {
  const alt = label ? `${label}` : "Gebruiker";

  if (url) {
    return (
      <img
        src={url}
        alt=""
        className={`shrink-0 rounded-full border border-wa-border/60 object-cover ${className}`}
        loading="lazy"
        decoding="async"
      />
    );
  }

  return (
    <UserCircleIcon
      className={`shrink-0 text-wa-muted/90 ${className}`}
      aria-hidden="true"
      title={alt}
    />
  );
};

export default NotificationAvatar;
